import { Link } from 'react-router-dom';
import { ROUTES } from '../Routes';
import React from 'react'; // React-i əlavə etdik
import footer18Icon from '../assets/footer_18.290455.png';
import footer_ecorga from '../assets/footer_ecorga.66827c.png';
import footer_gambleaware from '../assets/footer_gambleaware_ie.93c26f.png';
import footer_gamcare from '../assets/footer_gamcare.12e5f8.png';
import group12 from '../assets/Group-12.png';

// toggleCookieDialog propunu funksiya kimi qəbul edirik
const Footer = ({ toggleCookieDialog }) => {
  const footerLinks = [
    { name: 'Terms of use', href: ROUTES.TERMS_AND_CONDITIONS },
    { name: 'Responsible Gambling', href: ROUTES.RESPOSIBLE_GAMBLING },
    { name: 'CCPA Privacy Notice', href: ROUTES.CCPA_PRIVACY_NOTICE },
    { name: 'Accessibility Statement', href: ROUTES.ACCESSIBILITY_STATEMENT },
    { name: 'How We Rate', href: ROUTES.HOW_WE_RATE },
    { name: 'Privacy Policy', href: ROUTES.PRIVACY_POLICY },
    // Cookie Settings üçün linki dinamik edirik
    { name: 'Cookie Settings', href: '#', className: 'osano-cookie-settings', isCookieSettings: true },
  ];

  const partnerIcons = [
    { src: footer18Icon, alt: '18+ icon' },
    { src: footer_ecorga, alt: 'eCOGRA', href: 'https://www.ecogra.org/' },
    { src: footer_gamcare, alt: 'GamCare', href: 'https://www.gamcare.org.uk/' },
    { src: footer_gambleaware, alt: 'GambleAware', href: 'https://gamblingcare.ie/' },
  ];

  return (
    <footer className="bg-[#151724] pt-[64px] relative z-[20]">
      <div className="flex flex-col sm:flex-row container !py-[80px]">

        <div className="links sm:border-r-[1px] pr-[56px] border-[#2F334E]">
          <p className="text-[16px] font-[800] text-[#E6E6E6]">QUICK LINKS</p>
          <div className="flex gap-[80px] text-[#E6E6E6] md:min-w-[220px]">
            <ul className="footer_menu">
              {footerLinks.map((link, index) => (
                <li key={index} className={`menu-item ${link.className || ''}`}>
                  {link.isCookieSettings ? (
                    // Əgər cookie settings-dirsə, Link deyil, düymə/link klikləyirik
                    <a 
                      href="#" 
                      onClick={(e) => {
                        e.preventDefault(); // Səhifənin yuxarı çıxmasını əngəllə
                        if (toggleCookieDialog) toggleCookieDialog(); // Funksiyanı çağır
                      }}
                    >
                      {link.name}
                    </a>
                  ) : (
                    // Digər normal linklər
                    <Link to={link.href}>{link.name}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="sm:pl-[56px] flex-1 max-w-[572px]">
          <div className="w-[182px] sm:w-[230px] my-[32px] sm:mt-0">
            <img
              loading="lazy"
              src={group12}
              width="149" height="32" alt="logo"
            />
          </div>

          <div>
            <p className="text-[#99A5C5] text-[12px]">
              This website is owned and operated by Ryze Beyond Ltd. Reproduction of this website, in whole or
              in part, is strictly prohibited. The offers featured in this website are applicable solely for
              players located in Ireland and over the age of 18. All offers might be subject to additional
              terms or restrictions, including age, territory and residence limitations, as determined by the
              applicable operator which we are not responsible for and we recommend that you review the fill
              offer&#039;s terms and the operator&#039;s terms of use. This website is an informative
              comparison site that aims to offer its users find helpful information regarding the products and
              offers that will be suitable for their needs. We are able to maintain a free, high-quality
              service by receiving advertising fees from the brands we review. These advertising fees,
              combined with our criteria and methodology, such as the conversion rates, our team of
              reviewer&#039;s finding and subjective experience and product popularity, impact the placement
              and position of the brands within the comparison table. We do not compare or include all service
              providers, brands and offers available in the market. Please, Gamble Responsibly.
            </p>

            {/* İkonlar */}
            <div className="flex gap-[15px] items-center mt-[8px]">
              {partnerIcons.map((icon, index) => (
                icon.href ? (
                  <a key={index} href={icon.href} target="_blank" rel="noopener noreferrer">
                    <img src={icon.src} alt={icon.alt} loading="lazy" height="40" />
                  </a>
                ) : (
                  <img key={index} src={icon.src} alt={icon.alt} loading="lazy" height="40" />
                )
              ))}
            </div>

            <p className="mt-[20px] text-[#99A5C5] text-[12px]">
              All rights reserved © 2026
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;